<template src="./index.html"></template>

<script>
import { format, parseISO, startOfMonth, isEqual } from 'date-fns'
import swal from 'sweetalert2'
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'

require('vue-simple-calendar/static/css/default.css')
import "@/assets/scss/vuexy/apps/simple-calendar.scss";
import $api from '@/plugins/axiosInstance.js'
import {ko} from 'vuejs-datepicker/dist/locale'

const today = new Date()
const ICONS = {
  exposure: 'fas fa-bullhorn',
  magazine: 'far fa-star',
  release_18h: 'far fa-clock',
  overseas: 'fas fa-globe-americas',
  genre_ccm: 'fas fa-church',
  overseas_complete: 'fab fa-spotify',
}
const ALBUM_TYPE_CATEGORY = {
  album: 'Album',
  ep: 'EP',
  single: 'Single',
}
import Vue from 'vue'
import {BButton, BTooltip,} from 'bootstrap-vue'
const EventClass = Vue.extend(BTooltip)


export default {
  components: {
    FullCalendar,
  },
  
  data () {
    return {
      ko : ko,
      selectMonth: new Date(),

      exposure: false,
      magazine: false,
      release18h: false,
      overseas: false,
      ccm: false,
      overseasComplete: false,
      calendarView: 'month',
      albumList: [],
      baseDate: today,
      events: [],
      tags :[[]],
      customButtons: {
        prev: {
          text: 'PREV',
          click: () => {
            const calendarApi = this.$refs.fullCalendar.getApi()
            calendarApi.prev()
            const currentStart = calendarApi.view.currentStart
            this.selectMonth = currentStart  
            this.checkBaseDay(currentStart)
          },
        },
        next: {
          text: 'NEXT',
          click: () => {
            const calendarApi = this.$refs.fullCalendar.getApi()
            calendarApi.next()
            const currentStart = calendarApi.view.currentStart
            console.log(currentStart);
            currentStart.getMonth()
            this.checkBaseDay(currentStart)
             this.selectMonth = currentStart  
          },
        },
        today: {
          text: 'TODAY',
          click: () => {
            const calendarApi = this.$refs.fullCalendar.getApi()
            calendarApi.today()
            const currentStart = calendarApi.view.currentStart
            this.checkBaseDay(currentStart)
             this.selectMonth = currentStart  
          },
        },
      },
      calendarOptions: {
        plugins: [dayGridPlugin],
        theme: true,
        defaultView: 'dayGridMonth',
        header: {
          left: 'prev,next,today',
          center: 'title',
          right: 'dayGridMonth,dayGridWeek,dayGridDay',
        },
        fixedWeekCount: false,
        defaultDate: today,
        selectable: true,
        selectHelper: true,
        eventLimit: true,
        views: {
          month: {
            titleFormat: {
              month: 'long',
              year: 'numeric',
            },
          },
          week: {
            titleFormat: {
              month: 'long',
              day: '2-digit',
              year: 'numeric',
            },
            eventLimit: 20,
          },
          day: {
            titleFormat: {
              day: '2-digit',
              month: 'long',
              year: 'numeric',
            },
            eventLimit: false,
          },
        },
        height: 768,
        editable: false,
        events: this.events,
        eventColor: '#384aa2',
        eventRender: function (info) {
          const icons = info.event.extendedProps.icon
          if (icons && icons.length > 0) {
            let fa = ''
            fa += info.event.title + '<br>'
            icons.forEach((icon) => { fa += `<i class='${icon} mr-1'></i>` })
            info.el.querySelector('.fc-title').innerHTML = fa
          }
        },
      },
      popData : {}
    }
  },
  beforeMount () {
    
    
  },
  mounted(){
   


    this.$nextTick(()=>{
   
      let baseDay = format(startOfMonth(today), 'yyyy-MM-dd')
      if(this.$route.query.date){
        baseDay = this.$route.query.date
        this.baseDate = this.$route.query.date
        this.selectMonth = this.$route.query.date
        const calendarApi = this.$refs.fullCalendar.getApi()
        calendarApi.gotoDate(this.$route.query.date)
      }
      this.queryEvents(baseDay).then((res) => {
      }).catch((error) => {
        const status = error.response.status
        switch(status) {
          case 401:this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')});break;
          default:console.error(error);break;
        }
      })
    })
  },
  methods: {
    calendar(){
      
    },
    handleDateClick (info) {
      const calendarApi = this.$refs.fullCalendar.getApi()
      calendarApi.changeView('dayGridDay', info.dateStr)
    },
    handleEventClick (info) {
      console.log(info)
      const extendedProps  = info.event.extendedProps.data
      this.popData = extendedProps
      this.openModal('calendar')
      
    },
    checkBaseDay (dateParam) {
      console.log(dateParam);
      const currentBaseDay = startOfMonth(this.baseDate)
      const calendarBaseDay = startOfMonth(dateParam)
      
      if (!isEqual(currentBaseDay, calendarBaseDay)) {
        const baseDay = format(calendarBaseDay, 'yyyy-MM-dd')
        this.baseDate = dateParam
        
        this.queryEvents(baseDay).then((res) => {
          this.baseDate = dateParam
        }).catch(error=>{
          const status = error.response.status
          switch(status) {
            case 401:this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')});break;
            default:console.error(error);break;
          }
        })
      }
    },
    queryEvents (baseDay) {
      this.$router.replace({query: {date : baseDay}}).catch((e)=>{});
      return new Promise((resolve, reject) => {
        $api({
          method: 'get',
          url: '/calendar',
          params: { date: baseDay }
        }).then((res) => {
          this.albumList = [...res.data]
          this.switchTag(this.albumList)
          resolve(true)
        }).catch((err) => {
          reject(err)
        })
      })
    },
    createEvents (albumList) {
      this.events = []
      albumList.forEach((album,index) => {
        const albumTags = []
        if (album.tags && album.tags.length > 0 && album.tags[0].length > 0) albumTags.push(...album.tags[0])
        const icon = albumTags.map((tag) => ICONS[tag])
        const event = {}
        const albumName = album.name
        const artist = album.artists.length > 0 ? album.artists[0] : '*'
        const albumType = album.release_type ? ALBUM_TYPE_CATEGORY[album.release_type].toUpperCase() : '*'
        const trackCount = album.track_count ? album.track_count : 0
        const dateStr = format(parseISO(album.release_date), 'yyyy-MM-dd')
        event.id = index 
        event.title = `${albumName} ${artist} ${albumType} 트랙수:${trackCount}`
        event.date = dateStr
        event.extendedProps = {}
        event.extendedProps.icon = icon
        event.extendedProps.data = album

        this.events.push(event)
      })
    },
    switchTag () {
      const enableTags = this.tags[0]
     

      let targetAlbumList = []
      if (enableTags.length > 0) {
        targetAlbumList = this.albumList.filter((album) => {
          const albumTags = []
          if (album.tags && album.tags.length > 0 && album.tags[0].length > 0) albumTags.push(...album.tags[0])
          let enableFlg = false
          enableTags.forEach((tag) => {
            if (albumTags.includes(tag)) enableFlg = true
          })
          if (enableFlg) return true
          return false
        })
      } else {
        targetAlbumList = this.albumList
      }

      this.createEvents(targetAlbumList)
    },
    gotoDate (date) {
      const targetDate = new Date(date)
      const calendarApi = this.$refs.fullCalendar.getApi()
      calendarApi.gotoDate(targetDate)
      const currentStart = calendarApi.view.currentStart
      this.checkBaseDay(currentStart)
    },
  },
  watch: {
    tags(){
      this.switchTag()
    },
    baseDate(){
      //this.selectMonth= this.baseDate 
    },
    
  },
}
</script>
